import { Typography } from '@airtel/air-design-system';
import React from 'react';
import { VideoTimerProps } from './VideoModalPropTypes';

const VideoTimer: React.FC<VideoTimerProps> = ({ duration }) => {
   return duration ? (
      <div className="video-timer">
         <Typography
            type="title-single-line-md"
            text={duration}
            style={{
               fontSize: 12,
            }}
         />
      </div>
   ) : null;
};

export default VideoTimer;
